<template>
    <div class="querySteps">
        <topHead>
            <img slot="head" src="../../../assets/images/fh.png" alt="" @click="backBefor()" />
            <h3 slot="header">查开卡记录</h3>
        </topHead>
        <div class="verify" v-if="ListShow == false">

            <div class="main">
                <div class="ipt">
                    <p>姓名</p>
                    <input type="text" maxlength="10" placeholder="请输入需要查询的姓名" v-model="name" />
                </div>
                <div class="ipt">
                    <p>身份证号</p>
                    <input type="text" placeholder="请输入需要查询的身份证号" v-model="idCardNumber" />
                </div>
                <van-button round type="info" @click="goCard">查询</van-button>
            </div>
        </div>

        <div class="step_con" v-if="ListShow">
            <div class="listData" v-for="(item, index) in List" :key="index">
                <div class="list_header">
                    <p>{{ item.applyEvent }}</p>
                </div>
                <div class="list_con">
                    <div class="list_left">
                        <p v-if="item.prodOfferId != ''">{{ item.prodOfferId }}</p>
                        <p>{{ item.serviceId }}</p>
                    </div>
                    <!-- <div class="list_middle">
                        <p>{{ item.acceptDate }}</p>
                    </div> -->
                    <div class="list_right">
                        <div class="status" v-if="item.status == '审核通过'" style="color: #07c160">
                            审核通过
                        </div>
                        <div class="status" v-if="item.status == '审核不通过'" style="color: #ee0a24">
                            审核不通过
                        </div>
                        <div class="status" v-if="item.status == '待审核'" style="color: #ff976a">
                            待审核
                        </div>
                        <div class="errordata" v-if="item.status != '待审核'" style="color: #fff" @click="select(item)">
                            详情
                        </div>
                    </div>
                </div>

            </div>

            <van-popup v-model="TwoDetailsShow" :style="{ width: '90%', height: '30%' }" close-icon-position="top-right"
                closeable>
                <div class="wrapper">
                    <div @click.stop class="block">
                        <div class="block_tit">
                            <span>详情</span>
                        </div>
                        <p class="block_con">{{ selectData.auditRemark }}</p>
                        <p class="block_con" v-if="selectData.status == '审核通过' && selectData.applyEvent != '号码销户'">{{
                            selectData.ifValid }}</p>
                    </div>
                </div>
            </van-popup>

            <div class="notData" v-if="List == ''">
                <van-empty description="暂无数据" />
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from "vant"
import API from "../../../common/api/api"
import topHead from "../../../components/topHead.vue"
export default {
    components: { topHead },
    data() {
        return {
            List: [],
            name: "",
            ListShow: false,
            idCardNumber: "",
            TwoDetailsShow: false,
            selectData: {},  // 选择的数据
        }
    },

    created() { },
    // 组件方法
    methods: {
        // 查询开卡记录校验
        goCard() {
            if (this.name == '') {
                Toast({
                    message: "请输入您的姓名",
                    position: "bottom",
                })
            } else if (this.idCardNumber == '') {
                Toast({
                    message: "请输入身份证号",
                    position: "bottom",
                })
            } else {
                // 校验用户信息
                API.getJson('CHECK_OPEN_PHONE_WORK', {
                    customerName: this.name,
                    identityCode: this.idCardNumber
                }).then(res => {
                    if (res.data) {
                        if (res.data.code == -100) {
                            Toast({
                                message: res.data.msg,
                                position: "bottom",
                            })
                        }
                    } else {
                        this.ListShow = true
                        this.List = res
                    }
                })
            }


        },
        select(item) {
            this.selectData = item
            this.TwoDetailsShow = true
        },
        backBefor() {
            this.$router.replace("/")
        },
    },

    computed: {},

    watch: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
.querySteps {
    width: 100%;
    height: 100%;

    .verify {
        .main {
            padding: 0 px2rem(30);

            .ipt {
                position: relative;
                width: 100%;
                height: px2rem(100);
                background-color: #f6f6f6;
                border-radius: px2rem(18);
                margin-top: px2rem(30);
                font-size: px2rem(26);
                padding: 0 px2rem(30);
                box-sizing: border-box;

                input {
                    width: 100%;
                    height: px2rem(100);
                    text-align: right;
                }

                p {
                    position: absolute;
                    left: px2rem(30);
                    top: 0;
                    height: px2rem(100);
                    line-height: px2rem(100);
                }
            }

            .van-button {
                display: flex;
                justify-content: center;
                text-align: center;
                width: px2rem(550);
                height: px2rem(80);
                line-height: px2rem(80);
                color: #fff;
                font-weight: bold;
                font-size: px2rem(28);
                background-color: #336289;
                margin: px2rem(90) auto 0;
                box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.2);
            }
        }
    }

    .step_con {
        width: 100%;
        height: 93%;
        padding: px2rem(20);
        overflow: auto;
        background: #f0f0f0;

        .listData {
            height: px2rem(240);
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            font-size: px2rem(26);
            margin-top: px2rem(30);
            border-radius: px2rem(30);
            border: px2rem(1) solid #000;
            background: #fff;

            .list_header {
                width: 100%;
                height: 30%;
                display: flex;
                align-items: center;
                font-weight: 600;
                padding: px2rem(10);
                border-bottom: px2rem(1) solid #aaa;


            }

            .list_con {
                width: 100%;
                height: 70%;
                display: flex;
                padding: px2rem(10);
                justify-content: space-around;
                align-items: center;
                color: #fcfef9;
                background-color: #3377f6;
                border-bottom-left-radius: px2rem(30);
                border-bottom-right-radius: px2rem(30);


                .list_left {
                    width: 30%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                }

                .list_middle {
                    width: 30%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding-bottom: px2rem(14);
                    text-align: center;
                }

                .list_right {
                    width: 20%;
                    height: 90%;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;

                    .errordata {
                        font-size: px2rem(24);
                    }
                }
            }


        }

        .wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 100%;
            position: relative;

            .close {
                position: fixed;
                top: px2rem(10);
                right: px2rem(10);
                font-size: px2rem(36);
            }

            .block {
                width: 100%;
                height: px2rem(340);
                background: #f8f8f8;
                font-size: px2rem(30);
                color: #000000;

                .block_tit {
                    width: 100%;
                    height: px2rem(50);
                    text-align: center;
                    background: #ffffff;
                    color: #636564;
                    font-size: px2rem(36);
                }

                .block_con {
                    padding: px2rem(20) px2rem(20);
                    line-height: px2rem(50);
                }
            }

            .van-icon-cross:before {
                color: #000;
                font-size: px2rem(120) !important;
            }

        }
    }
}
</style>